module.exports = __webpack_public_path__ + "img/9c8cab5.png";